export default __webpack_public_path__ + "static/media/teedovey_1.30378116.png";